export enum DBSTypes {
	Basic = "Basic",
	Standard = "Standard",
	Enhanced = "Enhanced",
	EnhancedBarredList = "Enhanced with Barred List",
}
